import { IRouteMatchParser } from './IRouteMatchParser';
import { IRouteMatches } from './IRouteMatches';
import { parseRouteMatch } from './parseRouteMatch';

export function getMatcher(matches: IRouteMatches): IRouteMatchParser {

  return <TMatch extends { [name: string]: any; }>(
    name: string,
    defaultValues: TMatch,
    parsers?: Partial<Record<keyof TMatch, (v: string) => any>>) => {

    const match = matches[name];

    return parseRouteMatch(match, defaultValues, parsers);
  };
}
